export { default } from './BancoAutoFinancieCarro';
